'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

var _Title = require('material-ui-icons/Title');

var _Title2 = _interopRequireDefault(_Title);

var _CSSTransform = require('./CSSTransform');

var _CSSTransform2 = _interopRequireDefault(_CSSTransform);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Tag = (_temp = _class = function (_EditorComponent) {
  _inherits(Tag, _EditorComponent);

  function Tag(props) {
    _classCallCheck(this, Tag);

    var _this = _possibleConstructorReturn(this, _EditorComponent.call(this, props));

    _objectDestructuringEmpty(props); // const {
    //   // props: objectProps,
    //   components,
    // } = object || {};


    var _ref = _this.getObjectWithMutations() || {},
        components = _ref.components; // const {
    // } = objectProps || {};


    _this.state = _extends({}, _this.state, {
      focused: false,
      components: components ? components.slice(0) : []
    });
    return _this;
  } // canBeDropped(dragItem) {
  //   // return dragItem.name === "Tag";
  //   return false;
  // }


  Tag.prototype.canBeChild = function canBeChild(child) {
    // return super.canBeChild(child) && child instanceof Tag;
    return false;
  };
  /**
   * Не выводим кнопки, так как иначе сбивается редактирование текста
   */


  Tag.prototype.renderAddButtons = function renderAddButtons(content) {
    return null;
  };

  Tag.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_Title2.default, null), ' HTML Tag'));
  };

  Tag.prototype.prepareDragItemProps = function prepareDragItemProps() {
    var tag = this.props.tag;
    return _extends({}, _EditorComponent.prototype.prepareDragItemProps.call(this), {
      tag: tag
    });
  }; // prepareDragItemComponents() {
  //   return [{
  //     name: "Tag",
  //     props: {
  //       text: "",
  //     },
  //     components: [],
  //   }];
  // }


  Tag.prototype.getRootElement = function getRootElement() {
    var _getComponentProps = this.getComponentProps(this),
        tag = _getComponentProps.tag;

    return tag;
  };

  Tag.prototype.renderMainView = function renderMainView() {
    var _this2 = this;

    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode,
        activeItem = _getEditorContext2.activeItem;

    var object = this.getObjectWithMutations();
    var _object$props = object.props,
        tag = _object$props.tag,
        text = _object$props.text;

    if (!tag) {
      return text;
    } else {
      var options = void 0;

      switch (tag.toLowerCase) {
        case "script":
          // case "link":
          console.error('Tag "' + tag + '" not allowed');
          return null;
          break;
      }

      if (inEditMode) {
        var _state = this.state,
            components = _state.components,
            newContent = _state.newContent,
            focused = _state.focused;

        var _getRenderProps = this.getRenderProps(),
            baseStyle = _getRenderProps.style;

        var style = _extends({
          outline: "none",
          height: "auto",
          width: "auto"
        }, baseStyle); // if (focused) {
        //   Object.assign(style, {
        //     border: "none",
        //   });
        // }


        switch (tag) {
          case "a":
            Object.assign(style, {
              border: "1px solid green"
            });
            break;
        }

        options = {
          // contentEditable: true,
          // contentEditable: activeItem === this,
          contentEditable: this.isActive(),
          suppressContentEditableWarning: true,
          style: style,
          onInput: function onInput(event) {
            var node = event.target;

            var content = _this2.makeNewContent(node);

            var components = content.components;
            Object.assign(_this2.state, {
              newContent: {
                components: components
              }
            });
          },
          onFocus: function onFocus(event) {
            // const {
            //   activeItem,
            // } = this.getEditorContext();
            // if (activeItem && activeItem === this) {
            //   this.setState({
            //     focused: true,
            //   });
            // }
            if (_this2.isActive()) {
              _this2.setState({
                focused: true
              });
            }
          },
          onBlur: function onBlur(event) {
            // const {
            //   activeItem,
            // } = this.getEditorContext();
            // if (activeItem === this) {
            if (_this2.isActive()) {
              var _newContent = _this2.state.newContent;

              if (_newContent) {
                var _components = _newContent.components;

                _this2.setComponents(_components);

                _this2.setState({
                  newContent: null
                });
              }
            }

            _this2.setState({
              focused: false
            });
          }
        };
      }

      return _EditorComponent.prototype.renderMainView.call(this, options);
    }
  };

  Tag.prototype.renderChildren = function renderChildren() {
    var object = this.getObjectWithMutations();
    var text = object.props.text;
    var itemComponents = this.state.components;

    if (itemComponents && itemComponents.length) {
      return _EditorComponent.prototype.renderChildren.call(this);
    } else return text;
  };

  Tag.prototype.renderBadge = function renderBadge(badge) {
    var focused = this.state.focused;
    return focused ? null : _EditorComponent.prototype.renderBadge.call(this, badge);
  };

  Tag.prototype.isVoidElement = function isVoidElement() {
    var _getComponentProps2 = this.getComponentProps(this),
        tag = _getComponentProps2.tag;

    return tag && ["img"].indexOf(tag) !== -1 ? true : _EditorComponent.prototype.isVoidElement.call(this);
  }; // shouldComponentUpdate() {
  //   return false;
  // }


  Tag.prototype.makeNewContent = function makeNewContent(node) {
    var _this3 = this; // const {
    //   components,
    // } = this.state;
    // return {
    //   components,
    // }


    var nodes = node.childNodes;
    var components = [];
    var content = {};
    nodes.forEach(function (n) {
      components.push(_this3.updateContent(n));
    });
    Object.assign(content, {
      components: components
    });
    return content;
  };

  Tag.prototype.updateContent = function updateContent(node) {
    var _this4 = this;

    var content = {
      name: "Tag",
      component: "Tag",
      props: {},
      components: []
    };
    var nodes = node.childNodes;
    var NodeName = node.nodeName.toLowerCase();

    if (NodeName === "#text") {
      NodeName = undefined;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      content.props.text = node.textContent;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      var attributes = node.attributes;
      node.getAttributeNames().map(function (name) {
        var _Object$assign;

        var value = attributes[name].value;

        switch (name) {
          // case "id":
          // case "src":
          // case "href":
          //   // case "editable":
          //   break;
          case "contenteditable":
            name = "contentEditable";
            break;

          case "class":
            name = "className";
            break;

          case "staticcontext":
            name = "staticContext";
            break;

          case "style":
            try {
              value = value ? (0, _CSSTransform2.default)(value) : undefined;
            } catch (error) {
              console.error(error);
              value = undefined;
            }

            break;

          default:
            ;
        }

        Object.assign(content.props, (_Object$assign = {}, _Object$assign[name] = value, _Object$assign));
      });
      var components = [];
      nodes.forEach(function (node) {
        components.push(_this4.updateContent(node, {}));
      });
      Object.assign(content, {
        components: components
      });
    }

    content.props.tag = NodeName;
    return content;
  };

  Tag.prototype.componentDidCatch = function componentDidCatch(error, info) {
    console.error(error, info);
  };

  Tag.prototype.getEditorField = function getEditorField(props) {
    var _this5 = this;

    var key = props.key,
        name = props.name,
        value = props.value;

    var field = _EditorComponent.prototype.getEditorField.call(this, props);

    var _getComponentProps3 = this.getComponentProps(this),
        tag = _getComponentProps3.tag;

    if (tag === "img" && name === "src") {
      return _react2.default.createElement('div', null, _react2.default.createElement('div', null, field), _react2.default.createElement('div', null, this.renderUploader(name, {
        onUpload: function onUpload(_ref2) {
          var path = _ref2.path;

          _this5.updateComponentProperty(name, '/images/big/' + path);
        }
      })));
    }

    return field;
  };

  return Tag;
}(_2.default), _class.Name = "Tag", _class.help_url = "https://front-editor.prisma-cms.com/topics/html-tag.html", _class.defaultProps = _extends({}, _2.default.defaultProps, {
  tag: "span" // text: "",
  // color: "default",
  // displayType: "span",
  // display: "inline-block",
  // contentEditable: true,

}), _temp);
exports.default = Tag;
module.exports = exports['default'];